<template>
  <div>

    <el-drawer
        title="Select News"
        custom-class="news-drawer"
        :visible.sync="drawer"
        direction="rtl"
        :append-to-body="true"
        :z-index="9999999"
        size="80%">

        <fg-input
            class="mb-4"
            type="search"
            name="search"
            label="Search News"
            v-model="searchQuery">
        </fg-input>

        <div class="search-results">
          <NewsCard 
            v-for="(item, index) in news"
            :key="index"
            image="https://kjc.sgp1.digitaloceanspaces.com/tukio/programmes/image-1564844721339.jpg"
            type="select"
            :news="item"
            @card-click="selectNews"
          ></NewsCard>
        </div>
        

    </el-drawer>

    <card card-body-classes="" no-footer-line>

      <h4 slot="header" class="title title-up">{{ (scope == 'edit') ? 'Update' : 'Create New' }} Glimpses Issue</h4>
      <form>
        <div class="row">

          <div class="col-3">
            <fg-input
              type="number"
              required
              name="volume"
              label="Volume"
              v-validate="modelValidations.volume"
              :error="getError('volume')"
              v-model="model.volume">
            </fg-input>
          </div>
          <div class="col-3">
            <fg-input
              type="number"
              required
              name="issue"
              label="Issue"
              v-validate="modelValidations.issue"
              :error="getError('issue')"
              v-model="model.issue">
            </fg-input>
          </div>
          <div class="col-3">
            <fg-input
              type="date"
              name="date"
              label="Date & Time"
              v-validate="modelValidations.date"
              :error="getError('date')"
              v-model="model.date">
              <el-date-picker 
                  v-model="model.date" 
                  type="datetime" 
                  placeholder="date">
              </el-date-picker>
            </fg-input>
          </div>
          <div class="col-3">
            <fg-input
                type="text"
                required
                name="draft"
                label="Draft Newsletter ?"
                v-validate="modelValidations.draft"
                :error="getError('draft')"
                v-model="model.draft">
                <n-switch v-model="model.draft" on-text="Yes" off-text="No"></n-switch>
            </fg-input>
          </div>

          <div class="col-12 mt-2">
            <NewsCard 
              type="main"
              :news="model.featured_news"
              @card-click="openDrawer('featured')"
            ></NewsCard>

            <NewsCard 
              v-for="(item, index) in model.news"
              :key="index"
              type="sub"
              :news="item"
              @card-click="removeNews(item)"
            ></NewsCard>

            <NewsCard 
              type="sub"
              :news="null"
              @card-click="openDrawer('news')"
            ></NewsCard>
          </div>


          <div class="col-12 text-center">
            <n-button @click.native.prevent="validate()" type="primary">{{ (scope == 'edit') ? 'Update' : 'Create' }} Glimpses</n-button>
          </div>
          
        </div>
      </form>

    </card>

  </div>
</template>
<script>
import { Card, Switch, NewsCard } from 'src/components';
import { Select, Option, Tag, Upload, Drawer, DatePicker } from "element-ui";

import { mapGetters } from 'vuex';

export default {
  components: {
    Card,
    NewsCard,
    [Select.name]: Select,
    [Option.name]: Option,
    [Tag.name]: Tag,
    [Switch.name]: Switch,
    [Upload.name]: Upload,
    [Drawer.name]: Drawer,
    [DatePicker.name]: DatePicker,
  },
  computed: {
    ...mapGetters({
        authTokens: 'getAuthTokens',
        news: 'getNews',
        newsletter: 'getNewsletter',
        issueNo: 'getIssueNo'
    }),
    scope(){
      return this.$route.path.includes('edit') ? 'edit' : 'add'
    }
  },
  data() {
    return {
        drawer: false,
        // scope: 'add',
        item: 'featured',
        searchQuery: null,
        model: {
            volume: null,
            date: null,
            issue: null,
            draft: true,
            featured_news: null,
            news: [],
            template: 1
        },
        modelValidations: {
            volume: {
                required: true,
            },
            issue: {
                required: true,
            },
            date: {
                required: true,
            },
            draft: {
                required: true,
            },
            featured_news: {
                required: true,
            },
        },
        filterMethod(query, item) {
            return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
        }
    };
  },
  methods: {
    getError(fieldName) {
        return this.errors.first(fieldName);
    },
    validate() {
        this.$validator.validateAll().then(isValid => {
            // this.$emit('on-submit', this.registerForm, isValid);

            if(isValid){
                
                switch(this.scope){
                    case 'add'  : this.$store.dispatch('createNewsletter', Object.assign({}, this.model)); break;
                    case 'edit' : this.$store.dispatch('updateNewsletter', Object.assign({}, this.model)); break;
                }
                
            }
        });
    },
    openDrawer(item){
      this.item = item
      this.drawer = true
    },
    selectNews(news){
      switch(this.item){
        case 'featured': 
          this.model.featured_news = news; break;
        case 'news':
          this.model.news.push(news);
          break;
      }
      this.drawer = false
    },
    removeNews(news){
      const index = this.model.news.indexOf(news);
      if (index > -1) {
        this.model.news.splice(index, 1);
      }
    }
  },
  mounted() {
    

    if(this.scope == 'add'){
      if(this.$route.params.volume){
        this.model.volume = this.$route.params.volume
        this.$store.dispatch('getIssueNo', this.model.volume)
      }
    }

    this.$store.dispatch('getNews');
    if(this.scope == 'edit'){
      this.$store.dispatch('getNewsletter', this.$route.params.id)
    }
  },
  watch: {
    searchQuery(value) {
        let result = this.tableData;
        if (value !== "") {
            this.$store.dispatch('searchNews', value);
        }
        else{
          this.$store.dispatch('getNews');
        }
    },
    newsletter(value){
      this.model = Object.assign({}, value)
    },
    issueNo(value){
      if(this.scope == 'add')
        this.model.issue = value
    }
  }
};
</script>

<style lang="scss">
.has-success.has-label:after, 
.has-danger.has-label:after {
    top: 43px;
}

.el-transfer-panel__filter.el-input{
  width: 85%;
}

.bootstrap-switch{
  display: block;
  width: 90px!important;
  height: 35px!important;

  &.bootstrap-switch-on{
      .bootstrap-switch-label{
          left: 70%;
      }
  }

  .bootstrap-switch-label{
      width: 35px!important;
      height: 35px!important;
  }

  .bootstrap-switch-handle-off,
  .bootstrap-switch-handle-on{
      font-weight: bold;
      line-height: 22px;
      text-indent: 10px;
      color: #273c75!important;
      width: 100%!important;
  }
  .bootstrap-switch-handle-off{
      text-indent: 15px;
  }
}

.ck-editor__editable {
  min-height: 300px;
  }

  .el-dialog__wrapper{
    position: fixed;
    height: 100vh;
    width: 50%;
    top: 0;
    right: 0px;
  }

  .news-drawer{
    .el-drawer__close-btn{
      outline: none;
    }

    .el-drawer__header{
      margin-bottom: 10px;
    }

    .el-drawer__body{
      padding: 5px 20px;

      label{
        display: none;
      }
    }

    .search-results{
      height: calc(100vh - 100px);
      overflow-y: auto;
    }
  }

</style>
